"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FILTER_TO_NOTIF_SETTINGS_COPY = exports.WAITING_FOR_TEAMMATE_REPLY_DEFAULT_TIME = exports.DEFAULT_FILTER_TYPES = exports.NumericOperators = void 0;
exports.NumericOperators = {
  EQ: 'equals',
  GT: 'greater_than',
  GTEQ: 'greater_than_eq'
};
exports.DEFAULT_FILTER_TYPES = ['all-convos', 'no-participants', 'my-convos'];
exports.WAITING_FOR_TEAMMATE_REPLY_DEFAULT_TIME = 2;
exports.FILTER_TO_NOTIF_SETTINGS_COPY = {
  'all-convos': 'All conversations',
  'no-participants': 'Conversations without participants',
  inbox: 'Conversations routed to inbox',
  team: 'Conversations routed to team',
  'routed-unresponded': 'Conversations waiting for teammate reply',
  'unresponded-time-since-routed': 'Conversations waiting for teammate reply',
  tag: 'Conversations routed to tag',
  compound: 'Conversations meeting your filters',
  participants: 'Conversations with specific participants',
  'my-convos': 'My Conversations'
};